// react
import React from "react";

// components
import { Spacer } from "../components/Spacer";

const DataSecurity = () => {
	return (
		<div style={{ padding: 16 }}>
			<p style={{ fontSize: 24, fontWeight: 800 }}>데이터 보안</p>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				아쿠쿠아에서 지원하는 개인정보 삭제
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					* 사용자 본인이 등록한 데이터를 삭제할 수 있습니다. 본인이
					등록한 데이터를 선택한 후, 삭제 버튼을 통해 사용자가 등록한
					데이터를 삭제할 수 있습니다. 삭제된 데이터는 더이상 다른
					사용자가 볼 수 없으며, 복구가 불가능합니다
				</p>
				<p>
					* 사용자 본인의 계정을 삭제할 수 있습니다. 계정 관리
					화면에서 탈퇴 버튼을 통해 계정 정보를 삭제할 수 있습니다.
					삭제된 계정은 더이상 사용할 수 없으며, 복구할 수 없습니다.
					또한, 계정 외의 정보들은 함께 삭제되지 않습니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>
				아쿠쿠아에서 지원하는 데이터 삭제
			</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>
					* 특정 정보 삭제. 아쿠쿠아에서 제공하는 "삭제"버튼을 통해
					사용자 본인이 등록한 데이터를 삭제할 수 있습니다. 삭제된
					데이터는 더이상 다른 사용자가 볼 수 없으며, 복구가
					불가능합니다.
				</p>
				<p>
					* 계정 영구 삭제. 아쿠쿠아에서 계정 삭제를 통해 서비스에
					등록된 사용자 본인의 계정 데이터를 삭제할 수 있습니다. 단,
					개인정보 보유 약관 및 관련 법령에 따라 데이터 보관이 필요한
					경우 데이터가 보관될 수 있습니다. 삭제된 데이터는 복구가
					불가능합니다.
				</p>
			</div>
			<Spacer distance={32} />

			<p style={{ fontSize: 24, fontWeight: 800 }}>데이터 삭제 기간</p>
			<Spacer distance={8} />

			<div style={{ paddingLeft: 16 }}>
				<p>* 아쿠쿠아는 아래의 경우 데이터를 파기합니다.</p>
			</div>
			<div style={{ paddingLeft: 32 }}>
				<p>* 데이터 수집 목적 달성시.</p>
				<p>* 정보의 필요성이 상실된 경우.</p>
			</div>
			<Spacer distance={32} />
		</div>
	);
};

export default DataSecurity;
